import { Link } from "@/i18n/routing";
import { IconWriteReview } from "@repo/assets/images";
import { ProductReview } from "@repo/components";
import { Button } from "@repo/ui";
import { getTranslations } from "next-intl/server";
const ReviewBar = async ({
  totalElements,
  overallRating,
  itemId,
  session
}) => {
  const t = await getTranslations("Common");
  return <div className="pb-4" id="reviewsSection" data-sentry-component="ReviewBar" data-sentry-source-file="ReviewBar.jsx">
      <div className="flex items-center">
        <span className="font-heading text-productDetails-reviewText rtl:font-arabic pe-3 text-xl font-medium md:text-4xl">
          {t("Reviews")}
        </span>
        {/*overallRating?.rating > 0 && (
          <span className="text-xl pt-0.5 flex">
            {overallRating?.rating} <IconRatingStar className="ms-2 mt-1" />
          </span>
         )*/}
        {/*totalElements > 0 && (
          <span className="text-[#838589] text-sm ps-3">{`(${totalElements} ${t(
            "Reviews"
          )})`}</span>
         )*/}
        <div className="ms-auto flex items-center">
          {/*
            <div className="flex items-center space-x-2 rtl:space-x-reverse">
            {[...Array(5)].map((_, index) => (
              <IconNoRatingStar key={index} />
            ))}
           </div>
            */}
          {session ? <ProductReview itemId={itemId} session={session} /> : <Link href="/login">
              <Button size="md" variant="ghost" className="flex items-center border-none !px-0 hover:bg-white hover:underline hover:drop-shadow-none">
                <IconWriteReview className="me-2" />
                {t("Login_To_Review")}
              </Button>
            </Link>}
        </div>
      </div>
    </div>;
};
export default ReviewBar;